import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
// Yazdığımız Combine Reducer'ı dahil ediyoruz
import rootReducer from './reducers';

const initialState = {};
const middleware = [thunk];

// Redux DevTools Extension support for Redux v5
const composeEnhancers = 
  (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) 
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
        traceLimit: 25,
      })
    : compose;

// Aslında dikkat etmemiz gereken tek şey 2 parametre
// rootReducer olarak yazdığımız reducers/index.js
// initialState olarak başlangıç State'i
const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;